import * as React from 'react';

var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgLoyaltyBrandGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 11.474a3.473 3.473 0 1 1 0-6.948 3.473 3.473 0 0 1 2.457 5.931A3.475 3.475 0 0 1 8 11.474Z",
  fill: "url(#a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 2.833,
  y1: 0,
  x2: 12.191,
  y2: 3.022,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFC878"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B88E50"
})))));

export { SvgLoyaltyBrandGradient as default };
